import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="flex justify-center mt-4">
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-1 mx-1 border border-black rounded-md text-sm ${currentPage === 1 ? 'bg-black text-white' : 'bg-white'}`}
      >
        Prev
      </button>
      <span className="px-2 py-1 text-sm">{`Page ${currentPage} of ${totalPages}`}</span>
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 mx-1 border border-black rounded-md text-sm ${currentPage === totalPages ? 'bg-black text-white' : 'bg-white'}`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
